// support for nested objects
const resolvePath = (object: any, path: string, defaultValue?) => path
   .split(/[.[\]'"]/)
   .filter(p => p)
   .reduce((o, p) => o ? o[p] : defaultValue, object);

export default resolvePath;